import React from 'react'
import { useTranslation } from 'react-i18next'
import "./retailPerformance.scss"

function RetailPerformance() {
  const { t } = useTranslation()

  return (
    <div className='container-retail-performance'>
      <h1>{t("examples.retail_sector.title")}</h1>
    </div>
  )
}

export default RetailPerformance